module.exports = __webpack_public_path__ + "img/signature@2x.d8d251a.webp";